import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/jedi-order': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M398.5 373.6c0 0 26.3-16.2 49.9-77.7 0 0-17 183.3-222 185.7h-4.1c-205.1-2.4-222-185.7-222-185.7 23.2 61.6 49.4 77.7 49.4 77.7-95.9-122.1-17.2-233.1-17.2-233.1-45.4 85.7 41.4 170.5 41.4 170.5-105-171.6 60.5-271.5 60.5-271.5-96.9 72.6 10.1 190.7 10.1 190.7-85.8 158.4 68.6 230.1 68.6 230.1s0.4-16.9 2.2-85.7l-34.5 36.2 24.2-47.4-62.6-9.1 62.6-9.1-20.2-55.5 31.4 45.9c2.3-87.9 7.9-305.9 7.9-306.9v-2.4 1-1 2.4c0.1 1.8 5.7 219.2 7.9 306.9l31.4-45.9-20.2 55.5 62.6 9.1-62.6 9.1 24.2 47.4s-30.2-31.7-34.5-36.2c1.8 68.8 2.2 85.7 2.2 85.7s154.4-71.7 68.6-230.1c0 0 107-118 10.1-190.7 0 0 165.5 100 60.5 271.5 0 0 86.8-84.7 41.4-170.5 0 0 78.7 111-17.2 233.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/jedi-order.js
// module id = 898
// module chunks = 0